import { createIcon } from './createIcon'

/** Triangle with exclamation point (warning sign). */
export const WarningIcon = createIcon({
  displayName: 'WarningIcon',
  viewBox: '0 0 14 12',
  path: [
    <path
      key="triangle-exclamation"
      d="M13.022 11.9994H0.66665C0.428476 11.9994 0.208397 11.8723 0.0893122 11.6661C-0.0297722 11.4598 -0.0297706 11.2057 0.0893164 10.9994L6.26665 0.332727C6.38583 0.126802 6.60572 0 6.84365 0C7.08158 0 7.30147 0.126802 7.42065 0.332727L13.598 10.9994C13.717 11.2056 13.7171 11.4595 13.5982 11.6658C13.4792 11.872 13.2594 11.9991 13.0213 11.9994H13.022ZM6.84465 1.99939L1.82398 10.6661H11.8667L6.84465 1.99939ZM7.50798 8.00006H6.17465V4.66606H7.50798V8.00006Z"
      fill="currentColor"
    />,
    <path
      key="dot"
      d="M6.17798 8.66739H7.51132V10.0007H6.17798V8.66739Z"
      fill="currentColor"
    />,
  ],
})
